var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { isDefined } from "../../utils/isDefined";
export function getItemNodeFormatting(column, values) {
    var formatter = function (value) {
        if (isDefined(value) && (column === null || column === void 0 ? void 0 : column.formatter)) {
            return column === null || column === void 0 ? void 0 : column.formatter(value);
        }
        return value;
    };
    return formatter(values[column.key]);
}
export function getBoolValueFromRow(item, row) {
    var getValue = function (disabled) {
        if (disabled === undefined)
            return false;
        if (typeof disabled === "boolean")
            return disabled;
        return isDefined(item) && disabled(item);
    };
    return Boolean(getValue(row));
}
export function tableHasAction(props) {
    return [props.link, props.onSelect, props.linkBuilder].some(function (p) {
        return isDefined(p);
    });
}
export function rowHasAction(item, tableProps) {
    if (tableProps.linkBuilder) {
        return tableProps.linkBuilder(item) !== null;
    }
    return [tableProps.link, tableProps.onSelect, tableProps.dropdown].some(function (p) {
        return isDefined(p);
    });
}
export function getTableHasDropdown(props) {
    var _a;
    return isDefined(props === null || props === void 0 ? void 0 : props.dropdown) && ((_a = props === null || props === void 0 ? void 0 : props.form) === null || _a === void 0 ? void 0 : _a.viewState) !== "edit";
}
export function getTableHasCheckboxSelection(props) {
    var _a, _b;
    return isDefined((_a = props === null || props === void 0 ? void 0 : props.form) === null || _a === void 0 ? void 0 : _a.type) && ((_b = props === null || props === void 0 ? void 0 : props.form) === null || _b === void 0 ? void 0 : _b.type) === "checkbox";
}
export function getCellLinkProps(item, link, onSelect, linkBuilder) {
    var cellLink = undefined;
    if (linkBuilder) {
        var builtLink = linkBuilder(item);
        cellLink =
            builtLink !== null ? { link: builtLink, role: "link" } : undefined;
    }
    var definedLink = __assign(__assign({}, link), { url: (link === null || link === void 0 ? void 0 : link.url) + ((link === null || link === void 0 ? void 0 : link.linkKey) ? item[link.linkKey] : "") });
    if (link === null || link === void 0 ? void 0 : link.url) {
        cellLink = { link: definedLink, role: "link" };
    }
    else if (onSelect) {
        cellLink = {
            role: "button",
            onClick: function () { return onSelect(item); },
        };
    }
    return cellLink;
}
export function getDrawerData(item, drawer) {
    if (drawer === undefined ||
        drawer === null ||
        item === undefined ||
        item === null) {
        return undefined;
    }
    return (drawer === null || drawer === void 0 ? void 0 : drawer.nodeKey) && item[drawer === null || drawer === void 0 ? void 0 : drawer.nodeKey];
}
export function getItemTooltipContent(column, values) {
    var formatter = function (value) {
        if (isDefined(value) && (column === null || column === void 0 ? void 0 : column.tipFormatter)) {
            return column === null || column === void 0 ? void 0 : column.tipFormatter(value);
        }
        return value || "";
    };
    return formatter(values[column.key]);
}
export function canShowTooltip(itemNode, heading) {
    return (typeof itemNode == "string" ||
        typeof itemNode == "number" ||
        heading.tipFormatter);
}
export var getAlternatingRow = function (rowIndex) {
    if (rowIndex === 0 || !!(rowIndex && !(rowIndex % 2)))
        return "even";
    return "odd";
};
